<template>
  <transition name="fade">
    <div v-show="isShow" v-on:click="GoTop()">{{msg}}</div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      Timer: null
    };
  },
  props: {
    msg: {
      type: String,
      default: "返回顶部"
    }
  },
  methods: {
    doit() {
      window.onscroll = () => {
        if (document.documentElement.scrollTop + document.body.scrollTop > 0) {
          this.isShow = true;
          this.$emit("callback", document.documentElement.scrollTop);
        } else {
          this.isShow = false;
          this.$emit("endback", 0);
        }
      };
    },
    GoTop() {
      clearInterval(this.Timer);
      this.Timer = setInterval(this.check, 10);
    },
    check() {
      if (document.documentElement.scrollTop + document.body.scrollTop < 1) {
        clearInterval(this.Timer);
      } else {
        document.documentElement.scrollTop /= 1.1;
        document.body.scrollTop /= 1.1;
      }
    }
  },
  mounted() {
    this.doit();
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  height: 0;
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/GobackTop.vue